import CommonTooltip from "components/Tooltip/CommonTooltip";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WhiteButton } from "styledComponents/buttons";

import avatar5 from "../../assets/img/avatar_5.svg";
import LeftArrow_3 from "../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../assets/img/icons/RightArrow_3.svg";
import DownLoadIcon from "../../assets/img/icons/download-dark.svg";
import SortIcon from "../../assets/img/icons/sortIcon.svg";
import "../../assets/scss/reportDateRange.css";
import AddSingleMemberDropdown from "../../components/CustomDropdown/AddSingleMemberDropdown";
import CreateProjectDropdown from "../../components/DropdownStyle/CreateProjectDropdown";
import ReactDateRangePicker from "../../components/ReactDateRangePicker/ReactDateRangePicker";
import Select from "../../components/ReactSelectDropdown";
import { filterOption } from "../../components/ReactSelectDropdown/ReactSelectDropdown";
import ClearFilterButton from "../../components/Search/clearFilterButton";
import { FilterButton } from "../../styledComponents/buttons";
import {
  CommonFlex,
  CommonFlexIcon,
  CommonFlexWrap,
  CommonGrid,
  CommonImage,
  FilterLabel,
  IconArrow,
  InputWithLabelSection,
} from "../../styledComponents/common";
import { SelectSection } from "../../styledComponents/payroll";
import HelperIcon from "../../components/HelperIcon/HelperIcon";

const PayrollFilter = ({
  selectedOrganization,
  selectedOffice,
  setSelectedOffice,
  officeOptions,
  selectedMember,
  setSelectedMember,
  margin,
  sortType,
  payablesData,
  toggleSort,
  tabSelect,
  toggle,
  handleExportPayrollHistory,
  hourlyPaymentHistory,
  onetimePaymentHistory,
  startDate,
  endDate,
  dateLabel,
  changeDateRange,
  onDateSelect,
  selectLastWeek,
  selectLastMonth,
  singleDateChange,
  historyType,
  getPayablesData,
  getHourlyPaymentHistory,
  getOnetimePaymentHistory,
  getOrganizationMembersShortList,
  getOfficeDetails,
  orgMembersShortList,
  officeMembersList,
}) => {
  const { t } = useTranslation();

  const [memberOptions, setMemberOptions] = useState([]);

  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
        start: moment(startDate).format("YYYY-MM-DD"),
        end: moment(endDate).format("YYYY-MM-DD"),
      };
      if (tabSelect === "hourly") {
        getPayablesData(payload);
      } else if (tabSelect === "history") {
        setTimeout(() => {
          let historyPayload = {
            organization_id: selectedOrganization.id,
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD"),
          };
          if (selectedOffice && selectedOffice.value) {
            historyPayload.office_id = selectedOffice.value;
          }
          if (selectedMember && selectedMember.id) {
            historyPayload.user_ids = [selectedMember.id];
          }
          if (historyType && historyType === "hourly_basis") {
            getHourlyPaymentHistory(historyPayload);
          } else if (historyType && historyType === "fixed_amount") {
            getOnetimePaymentHistory(historyPayload);
          }
        }, 200);
      }
      getOrganizationMembersShortList({
        organization_id: selectedOrganization.id,
      });
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (orgMembersShortList && orgMembersShortList.length > 0) {
      setMemberOptions(orgMembersShortList);
    } else if (orgMembersShortList && orgMembersShortList.length === 0) {
      setMemberOptions([]);
    }
  }, [orgMembersShortList]);

  useEffect(() => {
    if (officeMembersList && officeMembersList.length > 0) {
      let assigneeList = [];
      officeMembersList.map(assignee => {
        assigneeList.push({
          id: assignee.user.id,
          name: `${assignee.user.first_name} ${assignee.user.last_name}`,
          avatar: assignee.user.avatar ? assignee.user.avatar : avatar5,
        });
      });
      setMemberOptions(assigneeList);
    } else if (officeMembersList && officeMembersList.length === 0) {
      setMemberOptions([]);
    }
  }, [officeMembersList]);

  const onOfficeChange = e => {
    let organizationId = selectedOrganization ? selectedOrganization.id : "";
    if (organizationId) {
      if (tabSelect === "hourly") {
        const payload = {
          organization_id: organizationId,
          start: moment(startDate).format("YYYY-MM-DD"),
          end: moment(endDate).format("YYYY-MM-DD"),
        };
        if (selectedMember && e && e.value) {
          payload.user_ids = [selectedMember.id];
        }
        if (e && e.value) {
          payload.office_id = e.value;
        }
        getPayablesData(payload);
      } else if (tabSelect === "history") {
        let historyPayload = {
          organization_id: organizationId,
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
        };
        if (selectedMember && e && e.value) {
          historyPayload.user_ids = [selectedMember.id];
        }
        if (e && e.value) {
          historyPayload.office_id = e.value;
        }
        if (historyType && historyType === "hourly_basis") {
          getHourlyPaymentHistory(historyPayload);
        } else if (historyType && historyType === "fixed_amount") {
          getOnetimePaymentHistory(historyPayload);
        }
      }
      if (e && e.value) {
        let payload = {
          organization_id: selectedOrganization.id,
          office_id: e.value,
        };
        getOfficeDetails(payload);
      } else if (!e || e?.value === null) {
        getOrganizationMembersShortList({
          organization_id: selectedOrganization.id,
        });
      }
    }

    setSelectedOffice(e);
  };

  const onMemberSelect = e => {
    if (e && e.id) {
      let organizationId = selectedOrganization ? selectedOrganization.id : "";
      if (organizationId) {
        if (tabSelect === "hourly") {
          const payload = {
            organization_id: organizationId,
            start: moment(startDate).format("YYYY-MM-DD"),
            end: moment(endDate).format("YYYY-MM-DD"),
            user_ids: [e.id],
          };
          if (selectedOffice && selectedOffice.value) {
            payload.office_id = selectedOffice.value;
          }
          getPayablesData(payload);
        } else if (tabSelect === "history") {
          const historyPayload = {
            organization_id: organizationId,
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD"),
            user_ids: [e.id],
          };
          if (selectedOffice && selectedOffice.value) {
            historyPayload.office_id = selectedOffice.value;
          }
          if (historyType && historyType === "hourly_basis") {
            getHourlyPaymentHistory(historyPayload);
          } else if (historyType && historyType === "fixed_amount") {
            getOnetimePaymentHistory(historyPayload);
          }
        }
        setSelectedMember(e);
      }
    }
  };

  const clearSelectedMember = () => {
    let organizationId = selectedOrganization ? selectedOrganization.id : "";
    if (organizationId) {
      if (tabSelect === "hourly") {
        const payload = {
          organization_id: organizationId,
          start: moment(startDate).format("YYYY-MM-DD"),
          end: moment(endDate).format("YYYY-MM-DD"),
        };
        if (selectedOffice && selectedOffice.value) {
          payload.office_id = selectedOffice.value;
        }
        getPayablesData(payload);
      } else if (tabSelect === "history") {
        let historyPayload = {
          organization_id: organizationId,
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
        };
        if (selectedOffice && selectedOffice.value) {
          historyPayload.office_id = selectedOffice.value;
        }
        if (historyType && historyType === "hourly_basis") {
          getHourlyPaymentHistory(historyPayload);
        } else if (historyType && historyType === "fixed_amount") {
          getOnetimePaymentHistory(historyPayload);
        }
      }
    }
    setSelectedMember("");
  };

  const isExportDisabled =
    tabSelect === "hourly"
      ? !payablesData || payablesData.length === 0
      : !(
          (historyType === "hourly_basis" &&
            hourlyPaymentHistory?.length > 0) ||
          (historyType === "fixed_amount" && onetimePaymentHistory?.length > 0)
        );

  //export click function
  const handleExportClick = () => {
    // For hourly tab, check payablesData
    if (tabSelect === "hourly") {
      if (!payablesData || payablesData.length === 0) return;
      toggle();
      return;
    }
    // For history tab, check the correct history data
    if (tabSelect === "history") {
      const hasHistoryData =
        (historyType === "hourly_basis" && hourlyPaymentHistory?.length > 0) ||
        (historyType === "fixed_amount" && onetimePaymentHistory?.length > 0);

      if (!hasHistoryData) return;

      handleExportPayrollHistory();
    }
  };

  return (
    <CommonGrid
      columns="1fr 1fr"
      responsiveColumns="1fr"
      responsiveBreakpoint="560px"
      mobileColumns="1fr"
    >
      <SelectSection
        margin={margin}
        columns={
          isOperationType
            ? "minmax(150px, 200px) minmax(30px, 40px) minmax(420px, 440px)"
            : "minmax(30px, 40px) minmax(220px, 240px)"
        }
        gap="20px"
      >
        {isOperationType && (
          <InputWithLabelSection>
            <FilterLabel>Teams</FilterLabel>
            <Select
              isSearchable
              isClearable={selectedOffice?.value}
              value={selectedOffice}
              options={officeOptions}
              placeholder="Select teams..."
              isDisabled={selectedMember ? true : false}
              onChange={e =>
                e
                  ? onOfficeChange(e)
                  : onOfficeChange({
                      label: `(${t("all_teams")})`,
                      value: null,
                    })
              }
              styles={CreateProjectDropdown()}
              // clearable
              filterOption={filterOption}
              components={{
                IndicatorSeparator: () => null,
                ClearIndicator: props => {
                  return <ClearFilterButton {...props} />;
                },
              }}
            />
          </InputWithLabelSection>
        )}

        <InputWithLabelSection>
          <FilterLabel>For</FilterLabel>
          <AddSingleMemberDropdown
            assigneeManage={selectedMember}
            updateState={onMemberSelect}
            membersList={memberOptions}
            clearAssignee={() => clearSelectedMember()}
            closeDisabled={true}
            page={"payroll"}
          />
        </InputWithLabelSection>

        <CommonFlex responsiveBreakpoint="501px" gap="4px" alignItems="end">
          <InputWithLabelSection>
            <CommonFlex gap="6px" alignItems="center" disableResponsive>
              <FilterLabel>
                {t("date_range")}
                {` (${dateLabel})`}
              </FilterLabel>
              <HelperIcon text={t("choose_the_range_of_dates_you_want_the_payroll_data_for")} />
            </CommonFlex>
            <ReactDateRangePicker
              startDate={startDate}
              startDateId="custom-date-range-start-date"
              endDate={endDate}
              endDateId="custom-date-range-end-date"
              onDatesChange={changeDateRange}
              onDateSelect={onDateSelect}
              selectLastWeek={selectLastWeek}
              selectLastMonth={selectLastMonth}
              disableFutureDates={true}
            />
          </InputWithLabelSection>
          <CommonFlex disableResponsive={true} gap="4px">
            <IconArrow
              onClick={() => {
                singleDateChange("left");
              }}
              padding="5px"
              size="39px"
              src={LeftArrow_3}
            />
            <IconArrow
              onClick={() => {
                moment(endDate).isBefore(moment(), "day") &&
                  singleDateChange("right");
              }}
              disabled={!moment(endDate).isBefore(moment(), "day")}
              padding="5px"
              size="39px"
              src={RightArrow_3}
            />

            <WhiteButton
              type="nav"
              style={{
                height: "38px",
                padding: "0px 15px",
              }}
              onClick={() => onDateSelect(true)}
              borderRadius="6px"
            >
              Today
            </WhiteButton>
          </CommonFlex>
        </CommonFlex>
      </SelectSection>
      <CommonFlexIcon gap="8px" alignItems="flex-end" justifyContent="flex-end">
        <CommonTooltip tooltipText={sortType?.label}>
          <FilterButton
            style={{ width: "max-content", padding: "10px" }}
            onClick={() => toggleSort()}
          >
            <CommonImage
              src={SortIcon}
              alt="sort-icon"
              style={{
                transform:
                  sortType.value === "oldToNew"
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </FilterButton>
        </CommonTooltip>
        {(selectedOrganization?.role === "admin" ||
          selectedOrganization?.role === "owner" ||
          selectedOrganization?.role === "team_leader") &&
          tabSelect === "hourly" && (
            <CommonTooltip width="80px" tooltipText={"Export"}>
              <FilterButton
                disabled={isExportDisabled}
                style={{ width: "max-content", padding: "10px" }}
                onClick={handleExportClick}
              >
                <CommonImage src={DownLoadIcon} alt="export-icon" />
              </FilterButton>
            </CommonTooltip>
          )}
      </CommonFlexIcon>
    </CommonGrid>
  );
};

export default PayrollFilter;
